<template>
    <OttWidget>
        <component :is="widgetComponent"
                   :contactSectionOverride="contactSection"
                   :aboutSectionOverride="aboutSection"
                   :socialSectionOverride="socialSection"
                   :feedbackSectionOverride="feedbackSection"
                   :apiServer="apiServer">
        </component>
    </OttWidget>
</template>

<script>
import OttWidget from './OttWidget.vue';
import {Components} from 'ottuxlib';
const OttawaFooter = Components.OttawaFooter;

export default {
  name: 'OttFooterWidget',
  components: {
    OttWidget,
    OttawaFooter
  },
  data: function() {
    return {
      widgetComponent: 'OttawaFooter',
      contactSection: null,
      aboutSection: null,
      socialSection: null,
      feedbackSection: null,
      apiServer: 'https://ottawa.ca',
    }
  },
  created: function() {
    // Load any section overrides that may be present in the markup.
    if (typeof this.$root.contactMenu !== 'undefined' && this.$root.contactMenu !== null) {
      this.contactSection = JSON.parse(this.$root.contactMenu);
    }
    if (typeof this.$root.aboutMenu !== 'undefined' && this.$root.aboutMenu !== null) {
      this.aboutSection = JSON.parse(this.$root.aboutMenu);
    }
    if (typeof this.$root.socialMenu !== 'undefined' && this.$root.socialMenu !== null) {
      this.socialSection = JSON.parse(this.$root.socialMenu);
    }
    if (typeof this.$root.feedbackMenu !== 'undefined' && this.$root.feedbackMenu !== null) {
      this.feedbackSection = JSON.parse(this.$root.feedbackMenu);
    }
  },
  mounted: function() {
    if (typeof this.$root.contactMenu !== 'undefined' && this.$root.contactMenu !== null) {
      this.contactSection = JSON.parse(this.$root.contactMenu);
    }
    if (typeof this.$root.aboutMenu !== 'undefined' && this.$root.aboutMenu !== null) {
      this.aboutSection = JSON.parse(this.$root.aboutMenu);
    }
    if (typeof this.$root.socialMenu !== 'undefined' && this.$root.socialMenu !== null) {
      this.socialSection = JSON.parse(this.$root.socialMenu);
    }
    if (typeof this.$root.feedbackMenu !== 'undefined' && this.$root.feedbackMenu !== null) {
      this.feedbackSection = JSON.parse(this.$root.feedbackMenu);
    }
  }
}
</script>
